<div class="container-fluid mt-3">
    <div class="row">
        <div class="col-sm-12 col-md-6 col-lg col-xl">
          <mat-card>
            <mat-card-header>
                  <mat-card-title>Processamento: Carteiras</mat-card-title>
                  <button mat-mini-fab class="botao-dashboard botao-processamento">
                    <!-- <i class="fas fa-cogs"></i> -->
                    <i class="fab fa-whmcs"></i>
                  </button>
            </mat-card-header>
            <hr>
            <mat-card-content>
              <div class="card-box tilebox-one icon-aberto" [ngClass]="cardSeleted === CARD_TYPES.CARTEIRAS_PROCESSADAS ? 'on-card-seleted' : ''"
                     (click)="changeCardState(CARD_TYPES.CARTEIRAS_PROCESSADAS)">
                     <mat-progress-bar mode="indeterminate" *ngIf="loadingCartProcessadas$ | async"></mat-progress-bar>
                    <h6 style="display:inline;" class="text-muted  mb-3">Processadas </h6>
                    <h5 style="display:inline; padding-left: 80px; float: right" class="text-left ">{{ qtdCartProcessadas$ | async }}</h5>
                </div>
                <div class="card-box tilebox-one icon-aberto"
                     [ngClass]="cardSeleted === CARD_TYPES.CARTEIRAS_NAO_PROCESSADAS ? 'on-card-seleted' : ''"
                     (click)="changeCardState(CARD_TYPES.CARTEIRAS_NAO_PROCESSADAS)">
                     <mat-progress-bar mode="indeterminate" *ngIf="loadingCartNaoProcessadas$ | async"></mat-progress-bar>
                    <h6 style="display:inline;" class="text-muted  mb-3">Não processadas </h6>
                    <h5 style="display:inline; padding-left: 50px; float: right" class="text-left">{{ qtdCartNaoProcessadas$ | async }}</h5>
                </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-sm-12 col-md-6 col-lg col-xl">
          <mat-card>
            <mat-card-header>
                  <mat-card-title>Enquadramento: Carteiras</mat-card-title>
                  <button mat-mini-fab class="botao-dashboard botao-enquadramento-carteiras">
                    <i class="fas fa-file-alt"></i>
                  </button>
            </mat-card-header>
            <hr>
            <mat-card-content>
              <div class="card-box tilebox-one icon-aberto" [ngClass]="cardSeleted === CARD_TYPES.DESENQUADRADA ? 'on-card-seleted' : ''"
                     (click)="changeCardState(CARD_TYPES.DESENQUADRADA)">
                     <mat-progress-bar mode="indeterminate" *ngIf="loadingCartDesenquadrada$ | async"></mat-progress-bar>
                    <h6 style="display:inline;" class="text-muted  mb-3">Desenquadradas </h6>
                    <h5 class="text-left" style="display:inline; padding-left: 60px; float: right">{{ qtdCartDesenquadrada$ | async }}</h5>
                </div>
                <div class="card-box tilebox-one icon-aberto" [ngClass]="cardSeleted === CARD_TYPES.ENQUADRADA ? 'on-card-seleted' : ''"
                     (click)="changeCardState(CARD_TYPES.ENQUADRADA)">
                     <mat-progress-bar mode="indeterminate" *ngIf="loadingCartEnquadrada$ | async"></mat-progress-bar>
                     <h6 style="display:inline;" class="text-muted  mb-3">Enquadradas </h6>
                    <h5 class="text-left" style="display:inline; padding-left: 85px; float: right">{{ qtdCartEnquadrada$ | async }}</h5>
                </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-sm-12 col-md-6 col-lg col-xl">
          <mat-card>
            <mat-card-header>
                  <mat-card-title>Enquadramento: Regras</mat-card-title>
                  <button mat-mini-fab class="botao-dashboard botao-enquadramento-regras">
                    <i class="fas fa-tasks"></i>
                  </button>
            </mat-card-header>
            <hr>
            <mat-card-content>
              <div class="card-box tilebox-one icon-aberto" [ngClass]="cardSeleted === CARD_TYPES.REGRAS_PROCESSADAS ? 'on-card-seleted' : ''"
                     (click)="changeCardState(CARD_TYPES.REGRAS_PROCESSADAS)">
                     <mat-progress-bar mode="indeterminate" *ngIf="loadingRegraDesenquadrada$ | async"></mat-progress-bar>
                    <h6 style="display:inline;" class="text-muted  mb-3">Desenquadradas </h6>
                    <h5 class="text-left" style="display:inline; padding-left: 60px; float: right">{{ qtdRegraDesenquadrada$ | async }}</h5>
                </div>
                <div class="card-box tilebox-one icon-aberto" [ngClass]="cardSeleted === CARD_TYPES.REGRAS_NAO_PROCESSADAS ? 'on-card-seleted' : ''"
                     (click)="changeCardState(CARD_TYPES.REGRAS_NAO_PROCESSADAS)">
                     <mat-progress-bar mode="indeterminate" *ngIf="loadingRegraEnquadrada$ | async"></mat-progress-bar>
                    <h6 style="display:inline;" class="text-muted  mb-3">Enquadradas </h6>
                    <h5 style="display:inline; padding-left: 85px; float: right;" class="mb-3 text-center">{{ qtdRegraEnquadrada$ | async }}</h5>
                </div>
                <div class="card-box tilebox-one icon-aberto" [ngClass]="cardSeleted === CARD_TYPES.CANCELADO ? 'on-card-seleted' : ''"
                     (click)="changeCardState(CARD_TYPES.CANCELADO)">
                     <mat-progress-bar mode="indeterminate" *ngIf="loadingCartCanceladas$ | async"></mat-progress-bar>
                    <h6 style="display:inline;" class="text-muted  mb-3">Canceladas </h6>
                    <h5 style="display:inline; padding-left: 50px; float: right" class="text-left">{{ qtdCartCanceladas$ | async }}</h5>
                </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-sm-12 col-md-6 col-lg col-xl">
          <mat-card>
            <mat-card-header>
                  <mat-card-title>Associação: Carteiras</mat-card-title>
                  <button mat-mini-fab class="botao-dashboard botao-associacao-carteiras">
                    <i class="fas fa-link"></i>
                  </button>
            </mat-card-header>
            <hr>
            <mat-card-content>
              <div class="card-box tilebox-one icon-aberto" [ngClass]="cardSeleted === CARD_TYPES.COM_REGRAS ? 'on-card-seleted' : ''"
                     (click)="changeCardState(CARD_TYPES.COM_REGRAS)">
                     <mat-progress-bar mode="indeterminate" *ngIf="loadingCartAssociadas$ | async"></mat-progress-bar>
                    <h6 style="display:inline;" class="text-muted  mb-3">Com regras </h6>
                    <h5 style="display:inline; padding-left: 85px; float: right;" class="mb-3 text-center">{{ qtdCartAssociadas$ | async }}</h5>
                </div>
                <div class="card-box tilebox-one icon-aberto" [ngClass]="cardSeleted === CARD_TYPES.SEM_REGRAS ? 'on-card-seleted' : ''"
                     (click)="changeCardState(CARD_TYPES.SEM_REGRAS)">
                    <mat-progress-bar mode="indeterminate" *ngIf="loadingCartNaoAssociadas$ | async"></mat-progress-bar>
                    <h6 style="display:inline;" class="text-muted  mb-3">Sem regras </h6>
                    <h5 style="display:inline; padding-left: 85px; float: right;" class="mb-3 text-center">{{ qtdCartNaoAssociadas$ | async }}</h5>
                </div>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-sm-12 col-md-6 col-lg col-xl">
          <mat-card>
            <mat-card-header>
                  <mat-card-title>Ocorrências: Desenquadramentos</mat-card-title>
                  <button mat-mini-fab class="botao-dashboard botao-ocorrencias-desenquadramentos">
                    <i class="fas fa-list-alt"></i>
                  </button>
            </mat-card-header>
            <hr>
            <mat-card-content>
              <div class="card-box tilebox-one icon-aberto">
              </div>
              <div class="card-box tilebox-one icon-aberto">
              </div>
            </mat-card-content>
          </mat-card>
        </div>
    </div>
</div>
